module.exports = __webpack_public_path__ + "img/jsj.61d2f8b8.png";